<button class="btn btn-admin-green back-button" (click)="goBack()">
  <app-icon icon="arrow-back-outline" class="icon color-white"></app-icon>
</button>
